// import {
//   Lightbulb,
//   Palette,
//   Link2,
//   GitBranch,
//   Users,
//   FolderKanban,
//   GraduationCap,
//   Star,
// } from "lucide-react";

import {
  FaLightbulb,
  FaPalette,
  FaLink,
  FaProjectDiagram,
  FaUsers,
  FaFolderOpen,
  FaGraduationCap,
  FaStar,
} from "react-icons/fa";

const features = [
  {
    id: 1,
    title: "UX Fundamentals",
    description:
      "Learn user research, wireframing, and information architecture to build intuitive experiences.",
    icon: FaLightbulb,
  },
  {
    id: 2,
    title: "UI Design",
    description:
      "Master typography, color theory, layout, and component-based design systems.",
    icon: FaPalette,
  },
  {
    id: 3,
    title: "Prototyping",
    description:
      "Create interactive, high-fidelity prototypes that look and feel like the real product.",
    icon: FaLink,
  },
  {
    id: 4,
    title: "Product Thinking",
    description:
      "Align user needs with business goals to build products that solve real problems.",
    icon: FaProjectDiagram,
  },
];

const stats = [
  {
    type: "rating",
    value: "4.8/5",
    label: "learner rating",
  },
  {
    icon: FaUsers,
    value: "500+",
    label: "Students",
  },
  {
    icon: FaFolderOpen,
    value: "20+",
    label: "Practical Projects",
  },
  {
    icon: FaGraduationCap,
    value: "95%",
    label: "Completion Rate",
  },
];

const FeatureCardss = ({ feature }) => {
  const Icon = feature.icon;

  return (
    <div className="md:w-[400px] w-full rounded-xl border border-[#E8E8EC] bg-white p-4 shadow-[0_3px_12px_rgba(0,0,0,0.04)]">
      {/* Icon */}
      <div className="mb-4 flex h-9 w-9 items-center justify-center rounded-lg bg-[#F0F1FF] text-[#E17A01]">
        <Icon
          size={16}
          strokeWidth={1.8}
        />
      </div>

      {/* Title */}
      <h3 className="text-[14px] font-semibold text-[#202124]">
        {feature.title}
      </h3>

      {/* Description */}
      <p className="mt-2 text-[10px] leading-[1.7] text-[#73757D]">
        {feature.description}
      </p>
    </div>
  );
};

const StatsItem = ({ stat }) => {
  if (stat.type === "rating") {
    return (
      <div className="flex items-center gap-1.5 whitespace-nowrap">
        <div className="flex gap-[1px] text-[#E17A01]">
          {[1, 2, 3, 4, 5].map((star) => (
            <FaStar
              key={star}
              size={9}
              fill="currentColor"
              strokeWidth={1}
            />
          ))}
        </div>

        <span className="font-medium text-[#33343A]">{stat.value}</span>

        <span>{stat.label}</span>
      </div>
    );
  }

  const Icon = stat.icon;

  return (
    <div className="flex items-center gap-1.5 whitespace-nowrap">
      <Icon
        size={10}
        strokeWidth={1.8}
        className="text-[#4D4FD7]"
      />

      <span className="font-medium text-[#33343A]">{stat.value}</span>

      <span>{stat.label}</span>
    </div>
  );
};

const DesignFeatures = () => {
  return (
    <section className="overflow-hidden bg-[#FAFAFA]">
      <div className="overflow-hidden border-b border-[#EEEEF1] bg-white">
        <div className="flex w-max animate-stats-marquee">
          {/* First set */}
          <div className="flex items-center gap-16 px-8 py-3">
            {stats.map((stat, index) => (
              <StatsItem
                key={index}
                stat={stat}
              />
            ))}
          </div>

          {/* Duplicate set */}
          <div className="flex items-center gap-16 px-8 py-3">
            {stats.map((stat, index) => (
              <StatsItem
                key={`duplicate-${index}`}
                stat={stat}
              />
            ))}
          </div>
        </div>
      </div>

      <div className="py-9 md:py-10">
        <div className="mx-auto max-w-7xl px-6 text-center">
          <h2 className="text-[26px] font-bold leading-tight tracking-[-0.7px] text-[#202124] md:text-[30px]">
            Master the Full Stack of Design
          </h2>

          <p className="mx-auto mt-2 max-w-[480px] text-[10px] leading-[1.6] text-[#73757D] md:text-[11px]">
            Everything you need to build engaging, functional, and beautiful
            digital products.
          </p>
        </div>

        <div className="mx-auto mt-6  flex flex-cop gap-4  md:flex flex-wrap  sm:flex-row sm:flex-wrap sm:justify-center lg:flex-nowrap max-w-7xl justify-center  overflow-hidden px-6">
          {features.map((feature) => (
            <FeatureCardss
              key={feature.id}
              feature={feature}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default DesignFeatures;
